import { useMediaQuery } from '@mui/material'
import { emotionTheme } from '@styles/theme'

import { BaseModal2 } from '../BaseModal2'

import type { ReturnModalProps } from './types'

import * as S from './styles'

export const ReturnModal = ({
  open,
  headerIcon,
  headerTitle,
  cancelButtonText,
  confirmButtonText,
  title,
  message,
  warningMessage,
  isLoading,
  onConfirm,
  onClose,
  children,
  confirmButtonDisabled
}: ReturnModalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  return (
    <BaseModal2
      open={open}
      title={headerTitle}
      headerIcon={headerIcon}
      onClose={onClose}
      width={isMobile ? 'calc(100% - 20px)' : 470}
      footer={{
        cancelButtonText,
        confirmButtonText,
        loading: isLoading,
        confirmButtonDisabled,
        onConfirm,
        cancelButtonMinWidth: 'calc(50% - 8px)',
        confirmButtonMinWidth: 'calc(50% - 8px)'
      }}
    >
      <S.Content>
        {!!title && <S.Title>{title}</S.Title>}
        {!!message && <S.Message>{message}</S.Message>}
        {children}
        {!!warningMessage && <S.WarningMessage>{warningMessage}</S.WarningMessage>}
      </S.Content>
    </BaseModal2>
  )
}
